export default "/_next/static/chunks/fonts/Rubik-Regular-latin-62be76d70222b4da160f6ef20739a68b.woff2";